<template>
  <footer class="footer-area">
    <div class="container">
      <div class="row">
        <div class="col-lg-3 col-sm-6 col-md-6">
          <div class="single-footer-widget">
            <div class="logo">
              <a href="index.html#">
                <img src="assets/img/black-logo.png" alt="logo" />
              </a>
              <p>
                IRecharge Pay is a multifunction omni-channel payment system which provides convenient and safe digital alternatives to tendering/receiving payments.
              </p>
            </div>
            <ul class="social-links">
              <li>
                <a href="https://www.facebook.com/irechargeng" target="_blank">
                  <i class="fab fa-facebook-f"></i>
                </a>
              </li>
              <li>
                <a href="https://twitter.com/iRechargeNG" target="_blank">
                  <i class="fab fa-twitter"></i>
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/irechargeng" target="_blank">
                  <i class="fab fa-instagram"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-3 col-sm-6 col-md-6">
          <div class="single-footer-widget pl-5">
            <h3>Company</h3>
            <ul class="list">
              <li>
                <a href="#aboutUs">About Us</a>
              </li>
              <li>
                <a href="#features">Features</a>
              </li>
              <li>
                <a href="#pricing">Our Pricing</a>
              </li>
              <li>
                <a href="#blog">Latest News</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-3 col-sm-6 col-md-6">
          <div class="single-footer-widget">
            <h3>Support</h3>
            <ul class="list">
              <li>
                <a href="#">FAQ's</a>
              </li>
              <li>
                <a href="#">Privacy Policy</a>
              </li>
              <li>
                <a href="#">Terms & Condition</a>
              </li>
              <li>
                <a href="#">Community</a>
              </li>
              <li>
                <a href="#contact">Contact Us</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-3 col-sm-6 col-md-6">
          <div class="single-footer-widget">
            <h3>Address</h3>
            <ul class="footer-contact-info">
              <li>
                <span>Location:</span>3 Kaltungo Street, Off Egbedi Close, Off Ladoke Akintola Bouleverd, Garki 2, Abuja 
              </li>
              <li>
                <span>Email:</span>
                <a href="index.html#">hello@istrategytech.com </a>
              </li>
              <li>
                <span>Phone:</span>
                <a href="index.html#">08070791414</a>
              </li>
              <!-- <li>
                <span>Fax:</span>
                <a href="index.html#">+1-212-9876543</a>
              </li> -->
            </ul>
          </div>
        </div>
      </div>
      <div class="copyright-area">
        <p>
          © {{thisYear}} 
          <a href="https://istrategytech.com">Infostrategy Technology</a>. All rights reserved
        </p>
      </div>
    </div>
    <div class="map-image">
      <img src="assets/img/map.png" alt="map" />
    </div>
  </footer>
</template>

<script>
export default {
    computed: {
      thisYear() {
        var date = new Date();
        return date.getFullYear();
      }
    }
}
</script>